/**
 * 두 hex 색상 사이를 보간
 * @param color1 - 시작 색상 (hex)
 * @param color2 - 끝 색상 (hex)
 * @param t - 보간 값 (0-1)
 * @returns 보간된 색상 (hex)
 */
export function interpolateColor(color1: string, color2: string, t: number): string {
    const r1 = parseInt(color1.slice(1, 3), 16);
    const g1 = parseInt(color1.slice(3, 5), 16);
    const b1 = parseInt(color1.slice(5, 7), 16);

    const r2 = parseInt(color2.slice(1, 3), 16);
    const g2 = parseInt(color2.slice(3, 5), 16);
    const b2 = parseInt(color2.slice(5, 7), 16);

    const r = Math.round(r1 + (r2 - r1) * t);
    const g = Math.round(g1 + (g2 - g1) * t);
    const b = Math.round(b1 + (b2 - b1) * t);

    return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
}

/**
 * 반전 색상 반환 (현재는 항상 흰색)
 */
export function getInvertedColor(): string {
    return '#FFFFFF';
}

/**
 * hex 문자열을 숫자로 변환 (PixiJS용)
 * @param hex - hex 색상 문자열 (예: '#FFFFFF')
 * @returns 숫자 (예: 0xFFFFFF)
 */
export function hexStringToNumber(hex: string): number {
    return parseInt(hex.slice(1), 16);
}
